import { AppData } from "@/src/constants/app-data";

const INFO = [
    {
        label: "Visit",
        lines: ["42 Artisans Row", "Shoreditch, London", "EC2A 3NS"],
    },
    { label: "Hours", lines: ["Mon — Sat: 10am – 7pm", "Sun: 11am – 5pm"] },
    { label: "Email", lines: [`hello@${AppData["AppDomain"]}`] },
    { label: "Phone", lines: ["+44 20 7946 0321"] },
];

export function ContactInfo() {
    return (
        <div className="space-y-10">
            {INFO.map(({ label, lines }) => (
                <div key={label}>
                    <h3 className="text-xs uppercase tracking-widest text-stone-400 mb-3">
                        {label}
                    </h3>
                    {lines.map((line) => (
                        <p key={line} className="text-stone-700 font-light">
                            {line}
                        </p>
                    ))}
                </div>
            ))}
        </div>
    );
}
